import React, { useEffect, useState } from 'react';
import './modal-content-wrapper.scss';
import clsx from 'clsx';

/**
 * Component wrapper to work in the modal
 * @returns JSX Element
 */

const ModalContentWrapper = ({ currentStep, variant }) => {
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (!steps.some((step) => step.stepId === currentStep.stepId)) {
      setSteps([...steps, currentStep]);
    }
  }, [currentStep.stepId]);

  return (
    <div
      className={clsx(
        'modal-content-wrapper',
        { 'modal-content-wrapper--triple': variant === 'triple' },
        { 'modal-content-wrapper--double': variant === 'double' }
      )}
    >
      {steps.map((step) => (
        <div
          className={'modal-content-wrapper__step'}
          key={step.stepId}
          style={{ display: step.stepId === currentStep.stepId ? 'block' : 'none' }}
        >
          {React.cloneElement(step.component, step.stepId === currentStep.stepId ? currentStep.component.props : null)}
        </div>
      ))}
    </div>
  );
};

export default ModalContentWrapper;
